import type { Booking } from "@/types/Booking";

/**
 * Friendly label for the "Booking Type" well shown on /view-booking. Slot bookings are inherently
 * recurring so they read simply "Slot"; other types append ", repeat" when the booking carries a
 * recurrence. See BOOKING_RULES.md#r13 for slot semantics.
 */
export function bookingTypeWellLabel(booking: Pick<Booking, "type" | "recurrence" | "recurrencePattern">): string {
  const baseLabel = (() => {
    switch (booking.type) {
      case "slot":
        return "Slot";
      case "adhoc":
        return "Flexible";
      case "weekend":
        return "Weekend";
      case "prospect":
        return "Prospect";
      case "sessional":
        return "Sessional";
      case "system":
        return "System";
      default:
        return "Booking";
    }
  })();
  if (booking.type === "slot") return baseLabel;
  if (booking.recurrence || booking.recurrencePattern) return `${baseLabel}, repeat`;
  return baseLabel;
}
